import React from "react";
import { TextField, Tooltip, Box } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export default function CustomInputField({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  label,
  placeholder,
  type,
  disabled,
  startAdornment,
  multiline,
  minRows,
  withInfoIcon,
  infoMessage,
  fieldProps = {},
  onKeyDown
}) {
  const isDisabled = disabled || fieldProps?.disabled;
  const { onChange: _fieldOnChange, onBlur: _fieldOnBlur, value: _fieldValue, ...restFieldProps } = fieldProps;

  return (
    <div className="proModernFieldWrapper" style={{display: "flex", alignItems: "flex-start", gap: "8px", width: "100%"}}>
      <Box sx={{ flex: 1, minHeight: "72px" }}>
        <div style={{marginBottom: "6px", fontSize: "12px", fontWeight: 500, color: "#667085", letterSpacing: "0.3px"}}>
          {label?.replace(" *", "")}
          {label?.includes("*") && (
            <span style={{ color: "#DC2626", marginLeft: "2px" }}>*</span>
          )}
        </div>
        
        <TextField
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder ?? ""}
          type={type}
          disabled={isDisabled}
          fullWidth
          multiline={multiline}
          minRows={minRows}
          variant="outlined"
          onKeyDown={onKeyDown}
          error={!!error}
          helperText={helperText || " "}
          InputProps={{
            startAdornment,
            sx: {
              borderRadius: "10px",
              fontSize: "12px",
              fontWeight: 500,
              backgroundColor: "#F9FAFB",

              "& input": {
                padding: "10px 12px",
                color: "#111827"
              },

              "& textarea": {
                color: "#111827"
              },

              "& fieldset": {
                borderColor: "#D1D5DB"
              },

              "&:hover fieldset": {
                borderColor: "#D1D5DB"
              },

              "&.Mui-focused fieldset": {
                borderColor: "#2563EB",
                borderWidth: "1px"
              },

              "&&.Mui-disabled": {
                background: "#F3F4F6 !important"
              },

              "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "#D1D5DB"
              },

              "&.Mui-disabled input": {
                WebkitTextFillColor: "#111827",
                fontWeight: 700,
                opacity: 1
              },

              "& input.Mui-disabled": {
                WebkitTextFillColor: "#111827",
                fontWeight: 600,
                opacity: 1,
                background: "#F3F4F6 !important"
              },

              "& textarea.Mui-disabled": {
                background: "#F3F4F6 !important"
              }
            }
          }}
          sx={{
            "& .MuiFormHelperText-root": {
              minHeight: "20px",
              margin: "4px 14px 0",
              lineHeight: "1.5",
              color: error ? "#DC2626" : "transparent"
            }
          }}
          {...restFieldProps}
        />
      </Box>

      {/* Info Icon */}
      {withInfoIcon && (
        <Box sx={{display: "flex", alignItems: "flex-start", paddingTop: "6px"}}>
          <Tooltip title={infoMessage} placement="top" arrow>
            <HelpIcon
              color="primary"
              sx={{
                fontSize: 20,
                cursor: "help",
                transition: "color 0.2s ease",
                "&:hover": {
                  color: "#1F88E6"
                }
              }}
            />
          </Tooltip>
        </Box>
      )}
    </div>
  );
}